/* Maison Alméa — en-tête : menu, défilement, annonces. 30/09 perf : sorti de sections/z-header-masazen.liquid (fichier mis en cache, async).
   Réglages lus dans window.__mzHdrCfg (posé par la section). Attend son repère #almk-hdr → démarre au même moment qu'avant. */
(function almBoot(){
  if (document.readyState === 'loading' && !document.getElementById('almk-hdr')) { setTimeout(almBoot, 20); return; }
  var C = window.__mzHdrCfg || {};

(function() {
  const header = document.getElementById('mzHeader');
  const burger = document.getElementById('mzBurger');
  const overlay = document.getElementById('mzOverlay');
  const mobile = document.getElementById('mzMobile');
  const badge = document.getElementById('mzBadge');
  const isIndex = !!C.isIndex;
  const scrollTrigger = C.scrollTrigger;
  let lastScroll = 0;

  // ══════════════════════════════════════════════════════
  // DÉTECTION AUTO FOND CLAIR / SOMBRE
  // ══════════════════════════════════════════════════════
  // ── Thème header : noir ou blanc selon template (défini dans le customizer) ──
  const darkTemplates = C.darkTemplates || ['product'];
  const currentTemplate = C.currentTemplate || '';
  const isDarkPage = !isIndex && darkTemplates.map(t => t.trim()).includes(currentTemplate);

  if (isDarkPage) {
    header?.classList.add('mz-header--light-page');
  } else {
    header?.classList.remove('mz-header--light-page');
  }

  // ══════════════════════════════════════════════════════
  // ANNOUNCEMENT SLIDER
  // ══════════════════════════════════════════════════════
  /* 2026-08-26 — v2 DETERMINISTE (voir le commentaire du CSS .mz-ann-slide).
     Une seule fonction pose l'etat COMPLET : exactement une diapo .active, zero
     .leaving en attente, aucun setTimeout qui porte l'etat. Rien ne peut plus
     rester coince et la barre n'est jamais vide entre deux messages.
     En prime : la rotation s'arrete quand l'onglet n'est pas visible (les
     minuteries y sont bridees) et l'etat est remis au propre au retour. */
  const annSlides = document.querySelectorAll('.mz-ann-slide');
  let currentSlide = 0;

  function showSlide(index) {
    const n = annSlides.length;
    if (!n) return;
    const next = ((index % n) + n) % n;
    for (let i = 0; i < n; i++) {
      annSlides[i].classList.toggle('active', i === next);
      annSlides[i].classList.remove('leaving');
    }
    currentSlide = next;
  }
  function goToSlide(index) { showSlide(index); }

  document.getElementById('mzAnnPrev')?.addEventListener('click', () => goToSlide(currentSlide - 1));
  document.getElementById('mzAnnNext')?.addEventListener('click', () => goToSlide(currentSlide + 1));

  if (annSlides.length > 1) {
    const rotateSpeed = C.rotateSpeed || 4000;
    showSlide(currentSlide);
    setInterval(() => { if (!document.hidden) showSlide(currentSlide + 1); }, rotateSpeed);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) showSlide(currentSlide); });
  }

  // Cart badge
  if (badge && parseInt(badge.textContent) > 0) badge.classList.add('visible');
  window.updateCartBadge = function(count) {
    if (badge) { badge.textContent = count; badge.classList.toggle('visible', count > 0); }
  };

  // Connexion avec la section produit MZ
  document.addEventListener('cart:add', function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('visible', cart.item_count > 0);
        }
      });
    // Ouvrir le drawer du thème
    openThemeCartDrawer();
  });

  // Intercepter le clic sur l'icône panier pour ouvrir le drawer
  var cartActionLink = document.querySelector('.mz-action--cart');
  if (cartActionLink) {
    cartActionLink.addEventListener('click', function(e) {
      e.preventDefault();
      openThemeCartDrawer();
    });
  }

  function openThemeCartDrawer() {
    // Event générique au cas où ta section panier l'écoute
    document.dispatchEvent(new CustomEvent('cart:open'));

    // 1) HORIZON : <cart-drawer-component> (contient un <dialog>)
    var horizon = document.querySelector('cart-drawer-component');
    if (horizon) {
      if (typeof horizon.open === 'function') { horizon.open(); return; }
      if (typeof horizon.showDialog === 'function') { horizon.showDialog(); return; }
      var dlg = horizon.querySelector('dialog');
      if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return; }
    }

    // 2) Section panier custom (z-paniermasazen)
    var customSection = document.querySelector('[id*="paniermasazen"]');
    if (customSection) {
      var customDrawer = customSection.querySelector('[class*="drawer"], [class*="cart"], [class*="panier"]');
      if (customDrawer) {
        customDrawer.classList.add('is-open', 'active', 'open');
        customDrawer.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        return;
      }
    }

    // 3) DAWN / IMPULSE : <cart-drawer>
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return; }
      drawer.classList.add('is-open', 'active', 'open', 'animate');
      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');
      return;
    }

    // 4) cart-notification
    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.open === 'function') { notif.open(); return; }

    // 5) Bouton panier natif du thème
    var cartBtn = document.querySelector('[aria-controls="CartDrawer"], [aria-controls="cart-drawer"], [data-cart-toggle], [href="#cart-drawer"], [href="#CartDrawer"]');
    if (cartBtn) { cartBtn.click(); return; }

    // 6) Fallback : page panier
    window.location.href = '/cart';
  }

  // Mobile menu
  const mobileClose = document.getElementById('mzMobileClose');
  
  function toggleMenu() {
    const isOpen = mobile.classList.contains('open');
    mobile.classList.toggle('open');
    overlay.classList.toggle('open');
    burger.classList.toggle('active');
    document.body.style.overflow = isOpen ? '' : 'hidden';
  }
  
  const mobileNav = document.getElementById('mzMobileNav');
  let activeSub = null;

  function goToSub(targetId) {
    const sub = document.getElementById(targetId);
    if (!sub) return;
    sub.scrollTop = 0;
    sub.style.display = 'flex';
    sub.style.flexDirection = 'column';
    void sub.offsetWidth;
    sub.classList.add('active');
    activeSub = sub;
    mobile.scrollTop = 0;
  }

  function goBack() {
    if (!activeSub) return;
    activeSub.classList.remove('active');
    const subToHide = activeSub;
    setTimeout(() => { subToHide.style.display = 'none'; }, 350);
    activeSub = null;
  }

  function closeMenu() {
    if (activeSub) {
      activeSub.classList.remove('active');
      const subToHide = activeSub;
      setTimeout(() => { subToHide.style.display = 'none'; }, 350);
      activeSub = null;
    }
    mobile.classList.remove('open');
    overlay.classList.remove('open');
    burger.classList.remove('active');
    document.body.style.overflow = '';
  }

  function positionMenu() {
    mobile.style.top = '0';
    mobile.style.height = '100%';
    overlay.style.top = '0';
  }

  const pcMenu = document.getElementById('mzPcMenu');
  const pcOverlay = document.getElementById('mzPcOverlay');
  const pcClose = document.getElementById('mzPcClose');
  const pcCatItems = document.querySelectorAll('.mz-pc-cat-item[data-sub]');

  function openPcMenu() {
    pcMenu?.classList.add('open');
    pcOverlay?.classList.add('open');
    burger?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closePcMenu() {
    pcMenu?.classList.remove('open');
    pcOverlay?.classList.remove('open');
    burger?.classList.remove('active');
    document.body.style.overflow = '';
    pcCatItems.forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.mz-pc-sub').forEach(s => s.classList.remove('active'));
  }

  burger?.addEventListener('click', () => {
    const isDesktop = window.innerWidth > 1000;
    if (isDesktop) {
      pcMenu?.classList.contains('open') ? closePcMenu() : openPcMenu();
    } else {
      const isOpen = mobile.classList.contains('open');
      if (!isOpen) positionMenu();
      mobile.classList.toggle('open');
      overlay.classList.toggle('open');
      burger.classList.toggle('active');
      document.body.style.overflow = isOpen ? '' : 'hidden';
    }
  });

  pcClose?.addEventListener('click', closePcMenu);
  pcOverlay?.addEventListener('click', closePcMenu);

  pcCatItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      pcCatItems.forEach(i => i.classList.remove('active'));
      document.querySelectorAll('.mz-pc-sub').forEach(s => s.classList.remove('active'));
      item.classList.add('active');
      const subId = item.getAttribute('data-sub');
      document.getElementById(subId)?.classList.add('active');
    });
  });

  const pcMenuLeft = document.getElementById('mzPcLeft');
  const pcMenuRight = document.getElementById('mzPcRight');
  let pcCloseTimer = null;

  function clearPcSubs() {
    pcCatItems.forEach(i => i.classList.remove('active'));
    document.querySelectorAll('.mz-pc-sub').forEach(s => s.classList.remove('active'));
  }

  function scheduleClear() {
    clearTimeout(pcCloseTimer);
    pcCloseTimer = setTimeout(clearPcSubs, 180);
  }

  function cancelClear() {
    clearTimeout(pcCloseTimer);
  }

  pcMenu?.addEventListener('mouseleave', scheduleClear);
  pcMenu?.addEventListener('mouseenter', cancelClear);

  pcCatItems.forEach(item => {
    item.addEventListener('mouseleave', (e) => {
      const toEl = e.relatedTarget;
      if (pcMenuRight && (pcMenuRight === toEl || pcMenuRight.contains(toEl))) return cancelClear();
      if ([...pcCatItems].some(c => c === toEl || c.contains(toEl))) return cancelClear();
      scheduleClear();
    });
    item.addEventListener('mouseenter', cancelClear);
  });

  pcMenuRight?.addEventListener('mouseenter', cancelClear);
  pcMenuRight?.addEventListener('mouseleave', (e) => {
    const toEl = e.relatedTarget;
    if (!toEl) return scheduleClear();
    if ([...pcCatItems].some(c => c === toEl || c.contains(toEl))) return cancelClear();
    if (pcMenu && pcMenu.contains(toEl)) return cancelClear();
    scheduleClear();
  });

  document.querySelectorAll('.mz-pc-mid-item[data-3sub]').forEach(item => {
    item.addEventListener('mouseenter', () => {
      const parentSub = item.closest('.mz-pc-sub.is-3col');
      parentSub?.querySelectorAll('.mz-pc-mid-item').forEach(i => i.classList.remove('active'));
      parentSub?.querySelectorAll('.mz-pc-3col-sub').forEach(s => s.classList.remove('active'));
      item.classList.add('active');
      const subId = item.getAttribute('data-3sub');
      document.getElementById(subId)?.classList.add('active');
    });
  });

  const origCatEnter = (item) => {
    const sub = document.getElementById(item.getAttribute('data-sub'));
    if (sub?.classList.contains('is-3col')) {
      const firstMid = sub.querySelector('.mz-pc-mid-item[data-3sub]');
      if (firstMid) {
        firstMid.classList.add('active');
        document.getElementById(firstMid.getAttribute('data-3sub'))?.classList.add('active');
      }
    }
  };
  pcCatItems.forEach(item => {
    item.addEventListener('mouseenter', () => origCatEnter(item));
  });

  burger?.classList.remove('active');
  mobile?.classList.remove('open');
  overlay?.classList.remove('open');
  overlay?.addEventListener('click', closeMenu);

  document.querySelectorAll('.mz-mobile-item[data-target]').forEach(item => {
    item.addEventListener('click', () => {
      const target = item.getAttribute('data-target');
      goToSub(target);
    });
  });

  document.querySelectorAll('[data-back]').forEach(btn => {
    btn.addEventListener('click', goBack);
  });

  // Help Modal
  const helpBtn = document.getElementById('mzHelpBtn');
  const helpOverlay = document.getElementById('mzHelpOverlay');
  const helpModal = document.getElementById('mzHelpModal');
  const helpClose = document.getElementById('mzHelpClose');
  
  function openHelpModal() {
    helpOverlay?.classList.add('open');
    helpModal?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  
  function closeHelpModal() {
    helpOverlay?.classList.remove('open');
    helpModal?.classList.remove('open');
    document.body.style.overflow = '';
  }
  
  helpBtn?.addEventListener('click', openHelpModal);
  helpOverlay?.addEventListener('click', closeHelpModal);
  helpClose?.addEventListener('click', closeHelpModal);

  // ══════════════════════════════════════════════════════
  // SCROLL BEHAVIOR
  // ══════════════════════════════════════════════════════
  const morphLogo = (C.isIndex && C.morph) ? document.getElementById('mzMorphLogo') : null;

  let lastScrollY = window.scrollY;
  let ticking = false;
  let hideTimer = null;
  const TOP_ZONE = 5;
  const HIDE_DELAY = 0;
  const isMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : window.innerWidth <= 768; /* 30/09 perf : sans recalcul forcé */
  const THRESHOLD = isMobile ? 3 : 8;
  const ANN_HIDE_THRESHOLD = 30;
  const HEADER_HIDE_THRESHOLD = isMobile ? 300 : 300;

  function updateHeader() {
    const currentY = window.scrollY;
    const delta = currentY - lastScrollY;

    const ann = document.querySelector('.mz-ann');
    if (ann) {
      if (currentY > ANN_HIDE_THRESHOLD) {
        ann.classList.add('mz-ann--hidden');
      } else {
        ann.classList.remove('mz-ann--hidden');
      }
    }

    if (currentY <= TOP_ZONE) {
      clearTimeout(hideTimer);
      header.classList.remove('mz-header--hidden', 'mz-header--compact');
      if (C.isIndex) {
      if (morphLogo) { morphLogo.classList.remove('corner'); morphLogo.classList.add('center'); }
      }
    } else if (delta > THRESHOLD && currentY > HEADER_HIDE_THRESHOLD) {
      if (!header.classList.contains('mz-header--hidden')) {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          header.classList.add('mz-header--hidden');
          header.classList.remove('mz-header--compact');
          const ann = document.querySelector('.mz-ann');
          if (ann) ann.classList.add('mz-ann--hidden');
        }, HIDE_DELAY);
      }
    } else if (delta < -THRESHOLD) {
      clearTimeout(hideTimer);
      header.classList.remove('mz-header--hidden');
      header.classList.add('mz-header--compact');
      const annUp = document.querySelector('.mz-ann');
      if (annUp && currentY > ANN_HIDE_THRESHOLD) annUp.classList.add('mz-ann--hidden');
      if (C.isIndex) {
      if (morphLogo) { morphLogo.classList.remove('center'); morphLogo.classList.add('corner'); }
      }
    }

    lastScrollY = currentY;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
  }, { passive: true });

  // Predictive search
  const searchInputs = document.querySelectorAll('[data-search-input]');
  let searchTimeout;
  
  searchInputs.forEach(input => {
    const results = input.closest('.mz-search').querySelector('[data-search-results]');
    if (!results) return;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(searchTimeout);
      if (q.length < 1) { results.classList.remove('active'); return; }
      results.innerHTML = '<div class="mz-predictive-loading"></div>';
      results.classList.add('active');
      searchTimeout = setTimeout(() => fetchSearch(q, results), 300);
    });
    document.addEventListener('click', e => {
      if (!input.closest('.mz-search').contains(e.target)) results.classList.remove('active');
    });
  });
  
  function fetchSearch(q, container) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=5')
      .then(r => r.json())
      .then(data => renderSearch(data, q, container))
      .catch(() => { container.innerHTML = '<div class="mz-predictive-empty">Erreur</div>'; });
  }
  
  function renderSearch(data, q, container) {
    const r = data.resources.results;
    let html = '';
    let hasResults = false;
    if (r.products?.length) {
      hasResults = true;
      html += '<div class="mz-predictive-section"><div class="mz-predictive-title">Produkte</div>';
      r.products.forEach(p => {
        const price = '€' + p.price;
        const compare = p.compare_at_price_max > p.price ? '€' + p.compare_at_price_max : null;
        html += `<a href="${p.url}" class="mz-predictive-item">
          <img src="${p.image || ''}" alt="" loading="lazy" decoding="async">
          <div><div class="mz-predictive-item-title">${p.title}</div>
          <div class="mz-predictive-item-price">${compare ? `<span class="compare">${compare}</span><span class="sale">${price}</span>` : price}</div></div></a>`;
      });
      html += '</div>';
    }
    if (r.collections?.length) {
      hasResults = true;
      html += '<div class="mz-predictive-section"><div class="mz-predictive-title">Kollektionen</div>';
      r.collections.forEach(c => html += `<a href="${c.url}" class="mz-predictive-link">${c.title}</a>`);
      html += '</div>';
    }
    if (hasResults) {
      html += `<a href="/search?q=${encodeURIComponent(q)}" class="mz-predictive-view-all">Alle Ergebnisse ansehen</a>`;
    } else {
      html = `<div class="mz-predictive-empty">Keine Ergebnisse für „${q}“</div>`;
    }
    container.innerHTML = html;
  }
})();

})();
